// // // pages/assessment/FoldersList.jsx
// // import { useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import {
// //   Box,
// //   Typography,
// //   Grid,
// //   Card,
// //   CardContent,
// //   CardActions,
// //   Button,
// //   IconButton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   TextField,
// //   Alert,
// //   CircularProgress,
// //   Fab,
// // } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import EditIcon from "@mui/icons-material/Edit";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import FolderIcon from "@mui/icons-material/Folder";
// // import { useATS } from "../atsModule/context/ATSContext";

// // const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // const FoldersList = () => {
// //   const navigate = useNavigate();
// //   const { store_id } = useATS();
// //   const [folders, setFolders] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [editingFolder, setEditingFolder] = useState(null);
// //   const [folderName, setFolderName] = useState("");
// //   const [folderDesc, setFolderDesc] = useState("");
// //   const [submitLoading, setSubmitLoading] = useState(false);

// //   const fetchFolders = async () => {
// //     if (!store_id && store_id !== 0) return;
// //     try {
// //       setLoading(true);
// //       const res = await axios.get(
// //         `${API_BASE}/api/assessment/assessment-folders`,
// //         {
// //           params: { store_id },
// //         },
// //       );
// //       setFolders(res.data.data || []);
// //       setError("");
// //     } catch (err) {
// //       console.error(err);
// //       setError("Failed to load folders");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchFolders();
// //   }, [store_id]);

// //   const handleOpenModal = (folder = null) => {
// //     if (folder) {
// //       setEditingFolder(folder);
// //       setFolderName(folder.name);
// //       setFolderDesc(folder.description || "");
// //     } else {
// //       setEditingFolder(null);
// //       setFolderName("");
// //       setFolderDesc("");
// //     }
// //     setModalOpen(true);
// //   };

// //   const handleCloseModal = () => {
// //     setModalOpen(false);
// //     setEditingFolder(null);
// //     setFolderName("");
// //     setFolderDesc("");
// //   };

// //   const handleSaveFolder = async () => {
// //     if (!folderName.trim()) {
// //       alert("Folder name is required");
// //       return;
// //     }
// //     setSubmitLoading(true);
// //     try {
// //       const payload = {
// //         store_id,
// //         name: folderName,
// //         description: folderDesc,
// //         parent_id: null, // no nested folders in UI
// //       };
// //       if (editingFolder) {
// //         await axios.put(
// //           `${API_BASE}/api/assessment/assessment-folders/${editingFolder.id}`,
// //           payload,
// //         );
// //       } else {
// //         await axios.post(
// //           `${API_BASE}/api/assessment/assessment-folders`,
// //           payload,
// //         );
// //       }
// //       fetchFolders();
// //       handleCloseModal();
// //     } catch (err) {
// //       console.error(err);
// //       alert(err.response?.data?.statusMessage || "Failed to save folder");
// //     } finally {
// //       setSubmitLoading(false);
// //     }
// //   };

// //   const handleDeleteFolder = async (folderId) => {
// //     if (
// //       !window.confirm(
// //         "Delete this folder? All assessments inside will also be deleted.",
// //       )
// //     )
// //       return;
// //     try {
// //       await axios.delete(
// //         `${API_BASE}/api/assessment/assessment-folders/${folderId}`,
// //         {
// //           data: { store_id },
// //         },
// //       );
// //       fetchFolders();
// //     } catch (err) {
// //       alert("Failed to delete folder");
// //     }
// //   };

// //   if (loading)
// //     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
// //   if (error) return <Alert severity="error">{error}</Alert>;

// //   return (
// //     <Box>
// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           mb: 3,
// //         }}
// //       >
// //         <Typography variant="h4" fontWeight={600}>
// //           Assessment Folders
// //         </Typography>
// //         <Fab
// //           color="primary"
// //           onClick={() => handleOpenModal()}
// //           sx={{ bgcolor: "#1a2a3a" }}
// //         >
// //           <AddIcon />
// //         </Fab>
// //       </Box>

// //       {folders.length === 0 ? (
// //         <Alert severity="info">No folders yet. Click + to create one.</Alert>
// //       ) : (
// //         <Grid container spacing={3}>
// //           {folders.map((folder) => (
// //             <Grid item xs={12} sm={6} md={4} key={folder.id}>
// //               <Card
// //                 sx={{
// //                   cursor: "pointer",
// //                   transition: "0.2s",
// //                   "&:hover": { transform: "translateY(-4px)", boxShadow: 3 },
// //                 }}
// //               >
// //                 <CardContent
// //                   onClick={() =>
// //                     navigate(`/ats/assessments/folder/${folder.id}`)
// //                   }
// //                 >
// //                   <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
// //                     <FolderIcon
// //                       sx={{ fontSize: 40, color: "#e4c769", mr: 1 }}
// //                     />
// //                     <Typography variant="h6" fontWeight={600}>
// //                       {folder.name}
// //                     </Typography>
// //                   </Box>
// //                   {folder.description && (
// //                     <Typography variant="body2" color="text.secondary">
// //                       {folder.description}
// //                     </Typography>
// //                   )}
// //                 </CardContent>
// //                 <CardActions sx={{ justifyContent: "flex-end" }}>
// //                   <IconButton
// //                     size="small"
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       handleOpenModal(folder);
// //                     }}
// //                   >
// //                     <EditIcon fontSize="small" />
// //                   </IconButton>
// //                   <IconButton
// //                     size="small"
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       handleDeleteFolder(folder.id);
// //                     }}
// //                   >
// //                     <DeleteIcon fontSize="small" />
// //                   </IconButton>
// //                 </CardActions>
// //               </Card>
// //             </Grid>
// //           ))}
// //         </Grid>
// //       )}

// //       {/* Create/Edit Folder Modal */}
// //       <Dialog
// //         open={modalOpen}
// //         onClose={handleCloseModal}
// //         maxWidth="sm"
// //         fullWidth
// //       >
// //         <DialogTitle>
// //           {editingFolder ? "Edit Folder" : "New Folder"}
// //         </DialogTitle>
// //         <DialogContent>
// //           <TextField
// //             autoFocus
// //             margin="dense"
// //             label="Folder Name"
// //             fullWidth
// //             value={folderName}
// //             onChange={(e) => setFolderName(e.target.value)}
// //             required
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Description (optional)"
// //             fullWidth
// //             multiline
// //             rows={2}
// //             value={folderDesc}
// //             onChange={(e) => setFolderDesc(e.target.value)}
// //           />
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleCloseModal}>Cancel</Button>
// //           <Button
// //             onClick={handleSaveFolder}
// //             variant="contained"
// //             disabled={submitLoading}
// //           >
// //             {submitLoading ? (
// //               <CircularProgress size={24} />
// //             ) : editingFolder ? (
// //               "Update"
// //             ) : (
// //               "Create"
// //             )}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default FoldersList;
// // pages/assessment/FoldersList.jsx
// // ─── REDESIGNED UI ONLY — all logic/state/API calls are unchanged ───────────
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   CardActions,
//   Button,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Alert,
//   CircularProgress,
//   Fab,
//   Skeleton,
//   Tooltip,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import FolderOpenIcon from "@mui/icons-material/FolderOpen";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
// import { useATS } from "../atsModule/context/ATSContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // ─── Design tokens ────────────────────────────────────────────────────────────
// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   900: "#1e3a8a",
// };

// const CARD_GRADIENTS = [
//   "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
//   "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
//   "linear-gradient(135deg, #fefce8 0%, #fef9c3 100%)",
//   "linear-gradient(135deg, #fdf4ff 0%, #fae8ff 100%)",
//   "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)",
//   "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
// ];

// const CARD_ICON_COLORS = [
//   "#2563eb",
//   "#16a34a",
//   "#ca8a04",
//   "#9333ea",
//   "#ea580c",
//   "#0891b2",
// ];

// // ─── Keyframe CSS injected once ───────────────────────────────────────────────
// const globalKeyframes = `
//   @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

//   @keyframes fadeUp {
//     from { opacity: 0; transform: translateY(24px); }
//     to   { opacity: 1; transform: translateY(0);    }
//   }
//   @keyframes shimmer {
//     0%   { background-position: -400px 0; }
//     100% { background-position:  400px 0; }
//   }
//   @keyframes float {
//     0%, 100% { transform: translateY(0px);   }
//     50%       { transform: translateY(-6px);  }
//   }
//   @keyframes pulseRing {
//     0%   { box-shadow: 0 0 0 0   rgba(37,99,235,.35); }
//     70%  { box-shadow: 0 0 0 10px rgba(37,99,235,0);   }
//     100% { box-shadow: 0 0 0 0   rgba(37,99,235,0);    }
//   }
// `;

// if (
//   typeof document !== "undefined" &&
//   !document.getElementById("fl-keyframes")
// ) {
//   const s = document.createElement("style");
//   s.id = "fl-keyframes";
//   s.textContent = globalKeyframes;
//   document.head.appendChild(s);
// }

// // ─── Motivational quote ───────────────────────────────────────────────────────
// const QUOTE = {
//   text: "The expert in anything was once a beginner.",
//   author: "",
// };

// // ─── Empty state ──────────────────────────────────────────────────────────────
// const EmptyState = ({ onAdd }) => (
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       py: 12,
//       gap: 2,
//       animation: "fadeUp .5s ease both",
//     }}
//   >
//     <Box
//       sx={{
//         width: 88,
//         height: 88,
//         borderRadius: "50%",
//         background: `linear-gradient(135deg, ${BLUE[100]} 0%, ${BLUE[200]} 100%)`,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         animation: "float 3s ease-in-out infinite",
//         boxShadow: `0 8px 24px ${BLUE[200]}`,
//       }}
//     >
//       <FolderOpenIcon sx={{ fontSize: 42, color: BLUE[600] }} />
//     </Box>
//     <Typography variant="h6" fontWeight={700} color="text.primary">
//       No folders yet
//     </Typography>
//     <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//       Create your first folder to organise your assessments.
//     </Typography>
//     <Button
//       variant="contained"
//       startIcon={<AddIcon />}
//       onClick={onAdd}
//       sx={fabSx}
//     >
//       Create Folder
//     </Button>
//   </Box>
// );

// // ─── Shared button style ──────────────────────────────────────────────────────
// const fabSx = {
//   background: "#0c8a9b",
//   color: "#fff",
//   borderRadius: "12px",
//   px: 3,
//   py: 1.2,
//   fontFamily: "'Plus Jakarta Sans', sans-serif",
//   fontWeight: 600,
//   boxShadow: `0 4px 14px #0c8a9ba8`,
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: `0 8px 20px #0c8a9b5d`,
//     background: `linear-gradient(135deg, #0c8a9b 0%, #0c8a9b 100%)`,
//   },
//   transition: "all .2s ease",
// };

// // ─── Skeleton card ────────────────────────────────────────────────────────────
// const SkeletonCard = () => (
//   <Card
//     sx={{
//       borderRadius: "20px",
//       overflow: "hidden",
//       boxShadow: "0 4px 20px rgba(0,0,0,.05)",
//       background: "#fff",
//     }}
//   >
//     <CardContent sx={{ p: 3 }}>
//       <Skeleton variant="circular" width={52} height={52} sx={{ mb: 2 }} />
//       <Skeleton variant="text" width="60%" height={28} />
//       <Skeleton variant="text" width="80%" height={20} sx={{ mt: 1 }} />
//     </CardContent>
//     <CardActions sx={{ px: 3, pb: 2 }}>
//       <Skeleton variant="rounded" width={90} height={34} />
//     </CardActions>
//   </Card>
// );

// // ─── Main component ───────────────────────────────────────────────────────────
// const FoldersList = () => {
//   const navigate = useNavigate();
//   const { store_id } = useATS();

//   // ── original state (unchanged) ──
//   const [folders, setFolders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editingFolder, setEditingFolder] = useState(null);
//   const [folderName, setFolderName] = useState("");
//   const [folderDesc, setFolderDesc] = useState("");
//   const [submitLoading, setSubmitLoading] = useState(false);

//   // ── original handlers (unchanged) ──
//   const fetchFolders = async () => {
//     if (!store_id && store_id !== 0) return;
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${API_BASE}/api/assessment/assessment-folders`,
//         { params: { store_id } },
//       );
//       setFolders(res.data.data || []);
//       setError("");
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load folders");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchFolders();
//   }, [store_id]);

//   const handleOpenModal = (folder = null) => {
//     if (folder) {
//       setEditingFolder(folder);
//       setFolderName(folder.name);
//       setFolderDesc(folder.description || "");
//     } else {
//       setEditingFolder(null);
//       setFolderName("");
//       setFolderDesc("");
//     }
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//     setEditingFolder(null);
//     setFolderName("");
//     setFolderDesc("");
//   };

//   const handleSaveFolder = async () => {
//     if (!folderName.trim()) {
//       alert("Folder name is required");
//       return;
//     }
//     setSubmitLoading(true);
//     try {
//       const payload = {
//         store_id,
//         name: folderName,
//         description: folderDesc,
//         parent_id: null,
//       };
//       if (editingFolder) {
//         await axios.put(
//           `${API_BASE}/api/assessment/assessment-folders/${editingFolder.id}`,
//           payload,
//         );
//       } else {
//         await axios.post(
//           `${API_BASE}/api/assessment/assessment-folders`,
//           payload,
//         );
//       }
//       fetchFolders();
//       handleCloseModal();
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.statusMessage || "Failed to save folder");
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const handleDeleteFolder = async (folderId) => {
//     if (
//       !window.confirm(
//         "Delete this folder? All assessments inside will also be deleted.",
//       )
//     )
//       return;
//     try {
//       await axios.delete(
//         `${API_BASE}/api/assessment/assessment-folders/${folderId}`,
//         { data: { store_id } },
//       );
//       fetchFolders();
//     } catch (err) {
//       alert("Failed to delete folder");
//     }
//   };

//   // ── render ──
//   return (
//     <Box
//       sx={{
//         borderRadius: 2,
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: "'Plus Jakarta Sans', sans-serif",
//         p: { xs: 2, sm: 4 },
//       }}
//     >
//       {/* ── Quote banner ──────────────────────────────────────────────────── */}
//       <Box
//         sx={{
//           mb: 4,
//           p: "14px 20px",
//           borderRadius: "14px",
//           background: "#0c8a9b",
//           display: "flex",
//           alignItems: "center",
//           gap: 1.5,
//           animation: "fadeUp .4s ease both",
//           boxShadow: `0 4px 18px ${BLUE[200]}`,
//         }}
//       >
//         <AutoAwesomeIcon
//           sx={{ color: "#fde68a", fontSize: 20, flexShrink: 0 }}
//         />
//         <Typography
//           sx={{
//             color: "#fff",
//             fontSize: "0.875rem",
//             fontWeight: 500,
//             fontStyle: "italic",
//             fontFamily: "'Plus Jakarta Sans', sans-serif",
//           }}
//         >
//           "{QUOTE.text}" <strong>{QUOTE.author}</strong>
//         </Typography>
//       </Box>

//       {/* ── Header ────────────────────────────────────────────────────────── */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 4,
//           animation: "fadeUp .45s ease both",
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 800,
//               fontFamily: "'Plus Jakarta Sans', sans-serif",
//               color: "#0c8a9b",
//               letterSpacing: "0.5px",
//             }}
//           >
//             Assessment Folders
//           </Typography>
//           <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//             Organise and manage all your assessment collections
//           </Typography>
//         </Box>

//         <Tooltip title="Create new folder" placement="left">
//           <Fab
//             onClick={() => handleOpenModal()}
//             sx={{
//               background: "#0c8a9b",
//               color: "#fff",
//               boxShadow: `0 4px 14px "#0c8a9b"`,
//               width: 52,
//               height: 52,
//               "&:hover": {
//                 transform: "scale(1.08)",
//                 boxShadow: `0 8px 22px #0c8a9bbd`,
//                 animation: "pulseRing 0.6s ease",
//                 background: "#0c8a9b",
//               },
//               transition: "all .2s ease",
//             }}
//           >
//             <AddIcon />
//           </Fab>
//         </Tooltip>
//       </Box>

//       {/* ── Error ─────────────────────────────────────────────────────────── */}
//       {error && (
//         <Alert
//           severity="error"
//           sx={{
//             borderRadius: "14px",
//             mb: 3,
//             fontFamily: "'Plus Jakarta Sans', sans-serif",
//           }}
//         >
//           {error}
//         </Alert>
//       )}

//       {/* ── Loading skeletons ─────────────────────────────────────────────── */}
//       {loading && (
//         <Grid container spacing={3}>
//           {[...Array(6)].map((_, i) => (
//             <Grid item xs={12} sm={6} md={4} key={i}>
//               <SkeletonCard />
//             </Grid>
//           ))}
//         </Grid>
//       )}

//       {/* ── Empty state ───────────────────────────────────────────────────── */}
//       {!loading && !error && folders.length === 0 && (
//         <EmptyState onAdd={() => handleOpenModal()} />
//       )}

//       {/* ── Folder cards ──────────────────────────────────────────────────── */}
//       {!loading && folders.length > 0 && (
//         <Grid container spacing={3}>
//           {folders.map((folder, idx) => {
//             const gradient = CARD_GRADIENTS[idx % CARD_GRADIENTS.length];
//             const iconColor = CARD_ICON_COLORS[idx % CARD_ICON_COLORS.length];
//             const delay = `${idx * 0.06}s`;

//             return (
//               <Grid item xs={12} sm={6} md={4} key={folder.id}>
//                 <Card
//                   sx={{
//                     borderRadius: "20px",
//                     background: "#fff",
//                     boxShadow:
//                       "0 4px 20px rgba(0,0,0,0.05), 0 1px 3px rgba(0,0,0,0.04)",
//                     border: "1px solid rgba(226,232,240,0.8)",
//                     cursor: "pointer",
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     animation: `fadeUp .5s ease ${delay} both`,
//                     transition: "all .25s cubic-bezier(.34,1.56,.64,1)",
//                     "&:hover": {
//                       transform: "scale(1.02) translateY(-4px)",
//                       boxShadow: `0 16px 40px rgba(37,99,235,.12), 0 4px 12px rgba(0,0,0,.06)`,
//                       borderColor: BLUE[200],
//                     },
//                     "&:hover .folder-icon-wrap": {
//                       transform: "rotate(-8deg) scale(1.1)",
//                     },
//                   }}
//                 >
//                   <CardContent
//                     onClick={() =>
//                       navigate(`/ats/assessments/folder/${folder.id}`)
//                     }
//                     sx={{ p: 3, flex: 1 }}
//                   >
//                     {/* Icon badge */}
//                     <Box
//                       className="folder-icon-wrap"
//                       sx={{
//                         width: 52,
//                         height: 52,
//                         borderRadius: "14px",
//                         background: gradient,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                         transition: "transform .25s ease",
//                       }}
//                     >
//                       <FolderSpecialIcon
//                         sx={{ fontSize: 28, color: iconColor }}
//                       />
//                     </Box>

//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontWeight: 700,
//                         fontFamily: "'Plus Jakarta Sans', sans-serif",
//                         color: "#0f172a",
//                         mb: 0.5,
//                       }}
//                     >
//                       {folder.name}
//                     </Typography>

//                     {folder.description && (
//                       <Typography
//                         variant="body2"
//                         sx={{
//                           color: "#64748b",
//                           lineHeight: 1.5,
//                           display: "-webkit-box",
//                           WebkitLineClamp: 2,
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                         }}
//                       >
//                         {folder.description}
//                       </Typography>
//                     )}
//                   </CardContent>

//                   <CardActions
//                     sx={{
//                       px: 3,
//                       pb: 2,
//                       pt: 0,
//                       justifyContent: "space-between",
//                       borderTop: "1px solid #f1f5f9",
//                     }}
//                   >
//                     <Button
//                       size="small"
//                       onClick={() =>
//                         navigate(`/ats/assessments/folder/${folder.id}`)
//                       }
//                       sx={{
//                         fontFamily: "'Plus Jakarta Sans', sans-serif",
//                         fontWeight: 700,
//                         color: "#0c8a9b",
//                         fontSize: "0.8rem",
//                         px: 1.5,
//                         py: 0.75,
//                         borderRadius: "8px",
//                         "&:hover": { background: BLUE[50] },
//                       }}
//                     >
//                       Open folder →
//                     </Button>

//                     <Box sx={{ display: "flex", gap: 0.5 }}>
//                       <Tooltip title="Edit folder">
//                         <IconButton
//                           size="small"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleOpenModal(folder);
//                           }}
//                           sx={{
//                             color: "#94a3b8",
//                             borderRadius: "8px",
//                             "&:hover": {
//                               color: BLUE[600],
//                               background: BLUE[50],
//                             },
//                             transition: "all .15s",
//                           }}
//                         >
//                           <EditIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                       <Tooltip title="Delete folder">
//                         <IconButton
//                           size="small"
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handleDeleteFolder(folder.id);
//                           }}
//                           sx={{
//                             color: "#94a3b8",
//                             borderRadius: "8px",
//                             "&:hover": {
//                               color: "#ef4444",
//                               background: "#fef2f2",
//                             },
//                             transition: "all .15s",
//                           }}
//                         >
//                           <DeleteIcon fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
//                     </Box>
//                   </CardActions>
//                 </Card>
//               </Grid>
//             );
//           })}
//         </Grid>
//       )}

//       {/* ── Create / Edit modal ───────────────────────────────────────────── */}
//       <Dialog
//         open={modalOpen}
//         onClose={handleCloseModal}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "20px",
//             boxShadow: "0 25px 60px rgba(0,0,0,.15)",
//             fontFamily: "'Plus Jakarta Sans', sans-serif",
//             overflow: "hidden",
//           },
//         }}
//         TransitionProps={{ style: { animationDuration: ".2s" } }}
//       >
//         {/* Coloured top strip */}
//         <Box
//           sx={{
//             height: 6,
//             background: `linear-gradient(90deg, "#0c8a9b" 0%, "#0c8a9b" 100%)`,
//           }}
//         />

//         <DialogTitle
//           sx={{
//             fontFamily: "'Plus Jakarta Sans', sans-serif",
//             fontWeight: 700,
//             fontSize: "1.15rem",
//             color: "#0f172a",
//             pt: 3,
//             pb: 1,
//           }}
//         >
//           {editingFolder ? "Edit Folder" : "Create New Folder"}
//         </DialogTitle>

//         <DialogContent sx={{ pt: 1 }}>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Folder Name"
//             fullWidth
//             value={folderName}
//             onChange={(e) => setFolderName(e.target.value)}
//             required
//             sx={inputSx}
//           />
//           <TextField
//             margin="dense"
//             label="Description (optional)"
//             fullWidth
//             multiline
//             rows={2}
//             value={folderDesc}
//             onChange={(e) => setFolderDesc(e.target.value)}
//             sx={inputSx}
//           />
//         </DialogContent>

//         <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//           <Button
//             onClick={handleCloseModal}
//             sx={{
//               fontFamily: "'Plus Jakarta Sans', sans-serif",
//               fontWeight: 600,
//               color: "#64748b",
//               borderRadius: "10px",
//               "&:hover": { background: "#f1f5f9" },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSaveFolder}
//             // variant="contained"
//             disabled={submitLoading}
//             sx={fabSx}
//           >
//             {submitLoading ? (
//               <CircularProgress size={20} sx={{ color: "#fff" }} />
//             ) : editingFolder ? (
//               "Save Changes"
//             ) : (
//               "Create Folder"
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// // ─── Shared TextField sx ──────────────────────────────────────────────────────
// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     fontFamily: "'Plus Jakarta Sans', sans-serif",
//     "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: BLUE[400] },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: BLUE[600],
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": { color: BLUE[600] },
// };

// export default FoldersList;

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  CircularProgress,
  Skeleton,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useATS } from "../atsModule/context/ATSContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// ─── Design tokens ─────────────────────────────────────────────────────────
const TEAL = "#0c8a9b";
const TEAL_LIGHT = "#e6f6f8";
const FONT = "'DM Sans', 'Inter', sans-serif";

const FOLDER_ICONS = [
  { bg: "#e8f5f7", color: TEAL },
  { bg: "#fef3e2", color: "#e07b00" },
  { bg: "#edf2ff", color: "#3b5bdb" },
  { bg: "#f3f0ff", color: "#7048e8" },
  { bg: "#e6fcf5", color: "#0ca678" },
  { bg: "#fff4e6", color: "#d9480f" },
];

// ─── Keyframes ──────────────────────────────────────────────────────────────
const KF_ID = "folders-kf";
if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const s = document.createElement("style");
  s.id = KF_ID;
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
    @keyframes fadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  `;
  document.head.appendChild(s);
}

// ─── TextField sx ────────────────────────────────────────────────────────────
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: FONT,
    fontSize: "0.9rem",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: TEAL },
};

// ─── Skeleton card ───────────────────────────────────────────────────────────
const SkeletonCard = () => (
  <Card
    sx={{
      borderRadius: "16px",
      boxShadow: "0 1px 4px rgba(0,0,0,.06)",
      background: "#fff",
    }}
  >
    <CardContent sx={{ p: 2.5 }}>
      <Skeleton
        variant="rounded"
        width={40}
        height={40}
        sx={{ borderRadius: "10px", mb: 1.5 }}
      />
      <Skeleton variant="text" width="55%" height={22} />
      <Skeleton variant="text" width="75%" height={16} sx={{ mt: 0.5 }} />
    </CardContent>
    <CardActions sx={{ px: 2.5, pb: 2 }}>
      <Skeleton
        variant="rounded"
        width={80}
        height={28}
        sx={{ borderRadius: "6px" }}
      />
    </CardActions>
  </Card>
);

// ─── Folder Menu ─────────────────────────────────────────────────────────────
const FolderMenu = ({ folder, onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{
          color: "#adb5bd",
          "&:hover": { color: "#495057" },
          borderRadius: "6px",
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 8px 24px rgba(0,0,0,.12)",
            minWidth: 140,
            fontFamily: FONT,
          },
        }}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
            onEdit(folder);
          }}
          sx={{ fontFamily: FONT, fontSize: "0.85rem", gap: 1 }}
        >
          <EditIcon sx={{ fontSize: 15, color: "#868e96" }} /> Edit
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
            onDelete(folder.id);
          }}
          sx={{
            fontFamily: FONT,
            fontSize: "0.85rem",
            color: "#e03131",
            gap: 1,
          }}
        >
          <DeleteIcon sx={{ fontSize: 15 }} /> Delete
        </MenuItem>
      </Menu>
    </>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
const FoldersList = () => {
  const navigate = useNavigate();
  const { store_id } = useATS();

  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingFolder, setEditingFolder] = useState(null);
  const [folderName, setFolderName] = useState("");
  const [folderDesc, setFolderDesc] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);

  const fetchFolders = async () => {
    if (!store_id && store_id !== 0) return;
    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE}/api/assessment/assessment-folders`,
        { params: { store_id } },
      );
      setFolders(res.data.data || []);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load folders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFolders();
  }, [store_id]);

  const handleOpenModal = (folder = null) => {
    if (folder) {
      setEditingFolder(folder);
      setFolderName(folder.name);
      setFolderDesc(folder.description || "");
    } else {
      setEditingFolder(null);
      setFolderName("");
      setFolderDesc("");
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingFolder(null);
    setFolderName("");
    setFolderDesc("");
  };

  const handleSaveFolder = async () => {
    if (!folderName.trim()) {
      alert("Folder name is required");
      return;
    }
    setSubmitLoading(true);
    try {
      const payload = {
        store_id,
        name: folderName,
        description: folderDesc,
        parent_id: null,
      };
      if (editingFolder) {
        await axios.put(
          `${API_BASE}/api/assessment/assessment-folders/${editingFolder.id}`,
          payload,
        );
      } else {
        await axios.post(
          `${API_BASE}/api/assessment/assessment-folders`,
          payload,
        );
      }
      fetchFolders();
      handleCloseModal();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.statusMessage || "Failed to save folder");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDeleteFolder = async (folderId) => {
    if (
      !window.confirm(
        "Delete this folder? All assessments inside will also be deleted.",
      )
    )
      return;
    try {
      await axios.delete(
        `${API_BASE}/api/assessment/assessment-folders/${folderId}`,
        { data: { store_id } },
      );
      fetchFolders();
    } catch (err) {
      alert("Failed to delete folder");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        background: "#f8f9fa",
        borderRadius: 0.4,
        fontFamily: FONT,
        p: { xs: 2, sm: 3.5 },
      }}
    >
      {/* ── Header ─────────────────────────────────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 3.5,
          animation: "fadeUp .4s ease both",
        }}
      >
        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontFamily: FONT,
              color: "#1a1d23",
              fontSize: "1.65rem",
              letterSpacing: "-0.3px",
            }}
          >
            Assessments
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#868e96",
              mt: 0.4,
              fontFamily: FONT,
              fontSize: "0.875rem",
            }}
          >
            Manage and organize your candidate evaluation tests.
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ fontSize: "16px !important" }} />}
          onClick={() => handleOpenModal()}
          sx={{
            background: TEAL,
            color: "#fff",
            borderRadius: "10px",
            px: 2,
            py: 0.9,
            fontFamily: FONT,
            fontWeight: 600,
            fontSize: "0.85rem",
            textTransform: "none",
            boxShadow: "none",
            "&:hover": { background: "#0a7a8a", boxShadow: "none" },
          }}
        >
          New Folder
        </Button>
      </Box>

      {/* ── Error ─────────────────────────────────────────────────────── */}
      {error && (
        <Alert
          severity="error"
          sx={{ borderRadius: "12px", mb: 3, fontFamily: FONT }}
        >
          {error}
        </Alert>
      )}

      {/* ── Loading ───────────────────────────────────────────────────── */}
      {loading && (
        <Grid container spacing={2.5}>
          {[...Array(4)].map((_, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <SkeletonCard />
            </Grid>
          ))}
        </Grid>
      )}

      {/* ── Empty state ───────────────────────────────────────────────── */}
      {!loading && !error && folders.length === 0 && (
        <Box
          sx={{
            textAlign: "center",
            py: 10,
            animation: "fadeUp .5s ease both",
          }}
        >
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: TEAL_LIGHT,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 2,
            }}
          >
            <FolderOutlinedIcon sx={{ fontSize: 34, color: TEAL }} />
          </Box>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ fontFamily: FONT, color: "#1a1d23" }}
          >
            No folders yet
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#868e96", mt: 0.5, fontFamily: FONT }}
          >
            Create your first folder to organise your assessments.
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleOpenModal()}
            sx={{
              mt: 2.5,
              background: TEAL,
              borderRadius: "10px",
              fontFamily: FONT,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#0a7a8a", boxShadow: "none" },
            }}
          >
            Create Folder
          </Button>
        </Box>
      )}

      {/* ── Folder Cards ──────────────────────────────────────────────── */}
      {!loading && folders.length > 0 && (
        <>
          {/* Section Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2.2,
            }}
          >
            <Typography
              sx={{
                fontFamily: FONT,
                fontWeight: 700,
                fontSize: "1.1rem",
                color: "#111827",
                letterSpacing: "-0.2px",
              }}
            >
              Department Folders
            </Typography>

            <Button
              sx={{
                fontFamily: FONT,
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.82rem",
                color: TEAL,
                minWidth: "auto",
                p: 0,
                "&:hover": {
                  background: "transparent",
                },
              }}
            >
              View All →
            </Button>
          </Box>

          <Grid container spacing={2.2}>
            {folders.map((folder, idx) => {
              const ic = FOLDER_ICONS[idx % FOLDER_ICONS.length];
              const delay = `${idx * 0.05}s`;

              return (
                <Grid item xs={12} sm={6} md={3} key={folder.id}>
                  <Card
                    onClick={() =>
                      navigate(`/ats/assessments/folder/${folder.id}`)
                    }
                    sx={{
                      borderRadius: "18px",
                      background: "#fff",
                      border:
                        idx === 2
                          ? "1px solid rgba(12,138,155,.22)"
                          : "1px solid #edf0f2",
                      boxShadow: "0 1px 2px rgba(16,24,40,.04)",
                      cursor: "pointer",
                      height: 170,
                      overflow: "hidden",
                      position: "relative",
                      animation: `fadeUp .45s ease ${delay} both`,
                      transition: "all .22s ease",
                      "&:hover": {
                        transform: "translateY(-3px)",
                        boxShadow: "0 10px 28px rgba(16,24,40,.08)",
                        borderColor: "rgba(12,138,155,.28)",
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        p: 2.3,
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* top */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                          mb: 2.3,
                        }}
                      >
                        <Box
                          sx={{
                            width: 42,
                            height: 42,
                            borderRadius: "12px",
                            background: ic.bg,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <FolderOutlinedIcon
                            sx={{
                              color: ic.color,
                              fontSize: 22,
                            }}
                          />
                        </Box>

                        <Box onClick={(e) => e.stopPropagation()}>
                          <FolderMenu
                            folder={folder}
                            onEdit={handleOpenModal}
                            onDelete={handleDeleteFolder}
                          />
                        </Box>
                      </Box>

                      {/* title */}
                      <Typography
                        sx={{
                          fontFamily: FONT,
                          fontWeight: 600,
                          fontSize: "0.95rem",
                          color: "#111827",
                          lineHeight: 1.2,
                          mb: 0.4,
                        }}
                      >
                        {folder.name}
                      </Typography>

                      {/* assessment count */}
                      <Typography
                        sx={{
                          fontFamily: FONT,
                          fontSize: "0.77rem",
                          color: "#6b7280",
                          fontWeight: 500,
                          mb: 1.6,
                        }}
                      >
                        {folder.assessment_count || 0} Assessments
                      </Typography>

                      {/* active folder tag */}
                      {idx === 2 && (
                        <Typography
                          sx={{
                            fontFamily: FONT,
                            fontSize: "0.72rem",
                            color: TEAL,
                            fontWeight: 700,
                          }}
                        >
                          Active Folder
                        </Typography>
                      )}

                      <Box sx={{ flexGrow: 1 }} />

                      {/* bottom avatars */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mt: 1.2,
                        }}
                      >
                        {["JD", "AS"].map((item, i) => (
                          <Box
                            key={i}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: "50%",
                              background: i === 0 ? "#c7f0f5" : "#d9f7e8",
                              color: "#0f172a",
                              fontSize: "0.62rem",
                              fontWeight: 700,
                              fontFamily: FONT,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "2px solid #fff",
                              ml: i === 0 ? 0 : -0.6,
                            }}
                          >
                            {item}
                          </Box>
                        ))}

                        <Box
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            background: "#ffe8c2",
                            color: "#7c4700",
                            fontSize: "0.62rem",
                            fontWeight: 700,
                            fontFamily: FONT,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "2px solid #fff",
                            ml: -0.6,
                          }}
                        >
                          +3
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </>
      )}

      {/* ── Create / Edit Modal ──────────────────────────────────────── */}
      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            fontFamily: FONT,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: FONT,
            fontWeight: 700,
            fontSize: "1rem",
            color: "#1a1d23",
            pt: 2.5,
            pb: 0.5,
          }}
        >
          {editingFolder ? "Edit Folder" : "Create New Folder"}
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Folder Name"
            fullWidth
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            required
            sx={inputSx}
          />
          <TextField
            margin="dense"
            label="Description (optional)"
            fullWidth
            multiline
            rows={2}
            value={folderDesc}
            onChange={(e) => setFolderDesc(e.target.value)}
            sx={inputSx}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1 }}>
          <Button
            onClick={handleCloseModal}
            sx={{
              fontFamily: FONT,
              fontWeight: 500,
              color: "#868e96",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": { background: "#f1f3f5" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveFolder}
            variant="contained"
            disabled={submitLoading}
            sx={{
              background: TEAL,
              borderRadius: "8px",
              fontFamily: FONT,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#0a7a8a", boxShadow: "none" },
            }}
          >
            {submitLoading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : editingFolder ? (
              "Save Changes"
            ) : (
              "Create Folder"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FoldersList;
